import React, { useEffect, useState } from 'react';
import { ReactSVG } from "react-svg";

import { useTheme } from '@mui/material/styles';
import { List, ListItem, Typography } from '@mui/material';
import { getStyles } from "../../../styles/subsidebar/styles";
import '../../../styles/subsidebar/styles.css';
import { IconSvg } from '../../../utils/globalIcons';
import { useAppContext } from '../../../context/AppContext';

function SubSidebar({ handleMenuChange, setSelectedMenuItem, selectedMenuItem }) {

    const theme = useTheme();
    const styles = getStyles(theme);
    const { selectedWorkspace, selectedProject } = useAppContext();

    useEffect(() => {
        const selected_engine_name = selectedProject?.payload?.configuration?.engine_name
        handleMenuChange(selected_engine_name)
        //eslint-disable-next-line
    }, [])

    const menuItems = [
        { icon: IconSvg.plugIcon, label: 'All Connectors', engine_name: "", icon_type: "svg", path: 'connectors' },
        { icon: IconSvg.plugConnectedIcon, label: 'Integrations', engine_name: "", icon_type: "svg", path: 'integrations' },
    ];

    const filteredMenuItems = () => {
        let items = []
        if (selectedWorkspace && selectedProject) {
            const selected_engine_name = selectedProject?.payload?.configuration?.engine_name
            const selected_sidebar_items = selectedProject?.payload?.configuration?.engine_config?.sidebar_items ?? {};
            const sub_sidebar_items = selected_sidebar_items?.['sources'] ?? [];
            const filteredMenuItems = menuItems?.filter(item => sub_sidebar_items?.map(subItem => subItem?.toLowerCase())?.includes(item?.path?.toLowerCase()));
            filteredMenuItems.forEach(item => { item.engine_name = selected_engine_name });
            items = filteredMenuItems;
        }
        return items;
    };

    const handleMenuItemClick = (index, engine, path) => {
        setSelectedMenuItem(index);
        handleMenuChange(engine, path)
    };

    return (

        <nav style={styles.sidebar}>
            <List>
                {filteredMenuItems()?.map((item, index) => (
                    <ListItem
                        key={index}
                        style={styles.siebarItem(selectedMenuItem, index)}
                        onClick={() => handleMenuItemClick(index, item.engine_name, item.path)}
                    >
                        <ReactSVG style={styles.siebarIcon} src={item.icon} className='sidebar_icon' />
                        <Typography sx={styles.siebarLabelText}>{item.label}</Typography>
                    </ListItem>
                ))}
            </List>
        </nav >
    );
}

export default SubSidebar;